// extracted by css-extract-rspack-plugin
export default {"container":"container-l12R3b"};